import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import { UseFormRegister } from "react-hook-form";
import { Controller } from "react-hook-form";

interface FdCheckboxProps extends CheckboxProps {
  label?: string | React.ReactNode;
  helperText?: string;
  value?: boolean;
  error?: boolean;
  checked?: boolean;
  register: UseFormRegister<any>;
  name: string;
  defaultValue?: any;
  defaultChecked?: boolean;
  control?: any;
}

const FdCheckbox = ({
  label,
  name,
  control,
  defaultChecked
}: FdCheckboxProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={false}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          control={<Checkbox checked={value} onChange={onChange} defaultChecked={defaultChecked}/>}
          label={label}
        />
      )}
    />
  );
};

export default FdCheckbox;
